import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { machines } from "../data/MachinesData.js";

const MachineDetailPage = () => {
  const { id } = useParams();
  const machine = machines.find((m) => m.id === id);
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (!id) return;

    fetch(`/machines/${id}/${id}.txt`, { cache: "no-store" })
      .then((res) => {
        if (!res.ok) throw new Error("Fichier non trouvé");
        return res.text();
      })
      .then((text) => setDescription(text))
      .catch(() =>
        setDescription("Aucune description disponible pour cette machine.")
      );
  }, [id]);

  if (!machine) return <div>Machine introuvable</div>;

  return (
    <div style={{ padding: "2rem" }}>
      <h1>{machine.name}</h1>

      {/* ✅ Image centrée au-dessus du texte */}
      <div style={{ textAlign: "center", margin: "20px 0" }}>
        <img
          src={`/machines/${id}/${id}0.png`}
          alt={`${machine.name} illustration`}
          style={{
            display: "block",
            margin: "0 auto 20px auto",
            maxWidth: "100%",
            height: "auto",
          }}
        />
      </div>

      <p style={{ whiteSpace: "pre-line" }}>{description}</p>

      {/* Liens vers les sous-pages */}
      <div style={{ marginTop: "1rem" }}>
        <Link
          to={`/machines/${id}/maquette`}
          className="steampunk-button"
          style={{ marginRight: "1rem" }}
        >
          Voir la maquette
        </Link>
        <Link to={`/machines/${id}/archives`} className="steampunk-button">
          Voir les archives
        </Link>
      </div>
    </div>
  );
};

export default MachineDetailPage;
